<p class="noted font-italic m-0">
  <span *ngIf="(serviceType | uppercase) === bookingEnum.EXPRESS">
    * Receive 10% off when you prepay online. Includes Taxes/Fees.
  </span>
  <span *ngIf="(serviceType | uppercase) === bookingEnum.LOGBOOK">
    Your service total price will be calculated after checking in your car and confirming the manufacturer's
    requirements at the service centre.
  </span>
</p>